/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Platforms_Available_TitleInputs */

const en_directory_platforms_available_title = /** @type {(inputs: Directory_Platforms_Available_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available platforms`)
};

const zh_directory_platforms_available_title = /** @type {(inputs: Directory_Platforms_Available_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用平台`)
};

/**
* | output |
* | --- |
* | "Available platforms" |
*
* @param {Directory_Platforms_Available_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_platforms_available_title = /** @type {((inputs?: Directory_Platforms_Available_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Platforms_Available_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_platforms_available_title(inputs)
	return zh_directory_platforms_available_title(inputs)
});
export { directory_platforms_available_title as "directory.platforms.available_title" }